<template>
  <div class="row">
    <div class="col-sm-12">

    </div>
  </div>
</template>

<script>
export default {
  name: 'individual',
  activated () {
    this.$store.commit('app/ui/changeTitle', 'Particuliers')
    this.$store.commit('app/ui/changeSubtitle', 'Gestion des appels particuliers.')
  }
}
</script>



// WEBPACK FOOTER //
// Individual.vue?5ce43dad